export default function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-3">
      <h2 className="font-mono text-[10px] tracking-[0.14em] uppercase text-slate-400 dark:text-slate-500">
        {title}
      </h2>
      <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 divide-y divide-slate-100 dark:divide-slate-800">
        {children}
      </div>
    </div>
  );
}
